import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ReadingPaneIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21.5 17.05"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 17.5)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="round"
    >
      <g transform="translate(.75 8.61)">
        <path d="m3.85 0a3.85 3.85 0 1 1 -3.85 3.85 3.85 3.85 0 0 1 3.85-3.85z" />
        <g strokeLinejoin="round">
          <circle cx="16.15" cy="3.85" r="3.85" />
          <path d="m7.7 3.92c0-.85 1.03-1.54 2.3-1.54s2.3.69 2.3 1.54" />
        </g>
      </g>
      <path d="m.75 12.05v-9.6l1.9-1.4" />
      <path d="m20.75 12.05v-9.6l-1.87-1.4" />
    </SVG>
  );
};
